(function ($) {
  function headerDropdown(e) {
    $("a.uk-navbar-toggle-animate svg").toggleClass("active");
    //alert("test");
  }

  $("a.uk-navbar-toggle-animate").click(headerDropdown);

  // FAQs dropdown on Homepage
  $(".faq-heading-mobile").click(function () {
    $(".faq-heading-mobile-icon").text(
      $(".faq-heading-mobile-icon").text() === "+" ? "-" : "+"
    );

    if ($(".faq-heading-mobile-icon").text() === "+") {
      $(".faq-items-container").addClass("padding");
    } else {
      $(".faq-items-container").removeClass("padding");
    }
  });
})(jQuery);